import { FC, ReactNode } from 'react';
import AsyncSelect from 'react-select/async';
import { StylesConfig, ClassNamesConfig } from 'react-select';
import { CityForSelectType } from '#home/types';
import {
  useCityChooserClassNames,
  useCityChooserStyles,
  useLoadOptions,
  useNoOptionsMessage,
} from '#components/city-chooser/hooks';

type PropsType = {
  id: string;
  placeholder: ReactNode;
  onChange: (selectedCity: CityForSelectType) => void;
  defaultValue?: CityForSelectType|null;
  styles?: StylesConfig|undefined;
  classNames?: ClassNamesConfig|undefined;
};

const CityChooser: FC<PropsType> = ({
  id,
  placeholder,
  onChange,
  defaultValue = null,
  styles: stylesInitial = undefined,
  classNames: classNamesInitial = undefined,
}) => {
  const styles = useCityChooserStyles(stylesInitial);
  const classNames = useCityChooserClassNames(classNamesInitial);
  const noOptionsMessage = useNoOptionsMessage();
  const loadOptions = useLoadOptions();

  return (
    <AsyncSelect
      instanceId={id}
      className={id}
      loadOptions={loadOptions}
      menuPlacement="top"
      defaultValue={defaultValue}
      onChange={onChange}
      components={{
        IndicatorSeparator: null,
        DropdownIndicator: null,
      }}
      noOptionsMessage={noOptionsMessage}
      placeholder={placeholder}
      aria-label="Find location"
      styles={styles}
      classNames={classNames}
    />
  );
};

export { CityChooser };
